module.exports = __webpack_public_path__ + "static/media/29DUNON10.d92c902f.jpg";